import { render, staticRenderFns } from "./aliMap.vue?vue&type=template&id=edc3367a&scoped=true"
import script from "./aliMap.vue?vue&type=script&lang=js"
export * from "./aliMap.vue?vue&type=script&lang=js"
import style0 from "./aliMap.vue?vue&type=style&index=0&id=edc3367a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc3367a",
  null
  
)

export default component.exports